import { render, staticRenderFns } from "./pcb.vue?vue&type=template&id=9680669e&scoped=true&"
import script from "./pcb.vue?vue&type=script&lang=js&"
export * from "./pcb.vue?vue&type=script&lang=js&"
import style0 from "./pcb.vue?vue&type=style&index=0&id=9680669e&prod&lang=scss&scoped=true&"
import style1 from "./pcb.vue?vue&type=style&index=1&id=9680669e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9680669e",
  null
  
)

export default component.exports